export { AddComment } from './AddComment';
export { default } from './AddComment';
export type { AddCommentProps } from './AddComment.types';
